<template>
  <div>
    <div class="bind-line-wrap">
      <h1>{{$t('upgrade_page_views_user_set_notice_1217')}}</h1>
      <h3>{{$t('upgrade_page_views_user_set_notice_1218')}}</h3>
      <h4>{{$t('upgrade_page_views_user_set_notice_1219')}}</h4>
      <dl>
        <dt>Step 1</dt>
        <dd>{{$t('upgrade_page_views_user_set_notice_1220')}}</dd>
        <dt>Step 2</dt>
        <dd>{{$t('upgrade_page_views_user_set_notice_1221')}}</dd>
        <dt>Step 3</dt>
        <dd>{{$t('upgrade_page_views_user_set_notice_1222')}}</dd>
        <dt>Step 4</dt>
        <dd>{{$t('upgrade_page_views_user_set_notice_1223')}}</dd>
      </dl>
      <div class="btn">
        <p>{{$t('upgrade_page_views_user_set_notice_1224')}}</p>
        <fps-switch v-model="isOpenLine" :loading="loading" @change="bindLineNotify" />
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo']),
    isOpenLine() {
      return this.userInfo && this.userInfo.boundLine && this.userInfo.lineNotifyOpen
    },
  },
  data() {
    return {
      href: '',
      loading: false,
    }
  },
  created() {
    const { code, state } = this.$route.query

    this.href = (process.env.VUE_APP_ENV === 'development' ? 'https://dev.3uplay.com' : location.origin) + location.pathname

    if (code && state) {
      this.saveLineNotifyCode(code, state)
    }

    if (window.opener) {
      window.opener.postMessage({
        type: 'BIND_LINE_NOTIFY_RESULT',
        data: true
      }, location.origin)
    }
  },
  mounted() {
    console.log(Notification.requestPermission())
  },
  methods: {
    bindLineNotify() {
      if (this.loading) return
      this.loading = true
      return this.userInfo.boundLine ? this.$http.get('/push/line/switch', {
        switch: this.userInfo.lineNotifyOpen ? 0 : 1
      }).catch(err => {
        // 切換LINE通知的接收狀態
        this.loading = false
        if ([2001, 2002, 2005].includes(err.code)) {
          this.$message.error(i18n.t('upgrade_page_views_user_set_notice_1225'))
        }
      }).then(() => {
        this.loading = false
        this.$store.dispatch('app/setSomeUserInfo', {
          lineNotifyOpen: !this.userInfo.lineNotifyOpen
        })
      }) : this.$http.post('/login/notify/authorize', {
        redirectUri: this.href
      }).then(({ data }) => {
        this.loading = false
        // 換取LINE的綁定鏈接
        if (data) {
          location.href = data
        }
      }).catch(err => {
        this.loading = false
        if ([2001, 2002, 2005].includes(err.code)) {
          this.$message.error(i18n.t('upgrade_page_views_user_set_notice_1225'))
        }
      })
    },
    saveLineNotifyCode(code) {
      // 存儲LINE Notify的token
      this.$http.post('/login/notify/token', {
        code,
        redirectUri: this.href,
        userUuid: this.userInfo.uuid
      }).then(({ data }) => {
        if (data) {
          this.$store.dispatch('app/setSomeUserInfo', {
            lineNotifyOpen: true
          })
          this.$router.replace({
            name: 'UserBindLine'
          }).then(() => {
            this.$store.dispatch('app/getUserInfo')
          })
        }
      }).catch(err => {
        if ([2001, 2002, 2005].includes(err.code)) {
          this.$message.error(i18n.t('upgrade_page_views_user_set_notice_1225'))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .bind-line-wrap {
    min-height: 585px;
    color: $color-gray-2;
    font-size: 14px;
    line-height: 20px;
    background: white;
    padding: 0 48px;

    h1 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      padding: 40px 0 24px;
      border-bottom: 1px solid #F4F4F4;
      color: $color-gray-1;
    }

    h3 {
      margin-top: 24px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
    }

    h4 {
      margin-top: 4px;
      font-weight: normal;
    }

    dl {
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      padding-bottom: 37px;
    }

    dt {
      position: relative;
      color: #FA006E;
      padding-left: 11px;

      &:not(:first-child) {
        margin-top: 20px;
      }

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: -0;
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: #FA006E;
        transform: translateY(-50%);
      }
    }

    dd {
      margin-top: 5px;
    }

    .btn {
      @include flex(space-between);
      height: 62px;
      padding-left: 8px;
      border-top: 1px solid $color-button;
      color: $color-gray-1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 500;
    }
  }
</style>